<template>
  <div class="home">
    <div class="home-search">
      <b-alert variant="danger" :show="showForbiddenMessage">
        You are not authorized to access this page.
      </b-alert>

      <b-alert :show="logoutSuccessfully" dismissible fade variant="info">
        <strong> Logout Successfully! </strong>
      </b-alert>

      <b-alert :show="loginSuccessfully" dismissible fade variant="success">
        <strong> Login Successfully! </strong>
      </b-alert>

      <div class="main search-form">
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-md-12 col-lg-10">
              <div class="heading">
                <h2>Sell tickets to your shows</h2>
                <h3>We help independent artists maximize marketing reach</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data: function () {
    return {
      events: [],
      showForbiddenMessage: this.$route.params.showForbiddenMessage,
      logoutSuccessfully: this.$route.params.logoutSuccessfully,
      loginSuccessfully: this.$route.params.loginSuccessfully
    }
  },
  watch: {
    '$route.params.logoutSuccessfully' (newValue, oldValue) {
      this.logoutSuccessfully = newValue
      this.loginSuccessfully = false
    }
  },
  created () {
    this.getEvents()
  },
  methods: {
    getEvents: function () {
      var self = this

      this.$http.get('public_access/events?limit=10').then(function (response) {
        self.events = response.data
      })
    },
    goToEvent (event) {
      this.$router.push({
        name: 'eventShow',
        params: {
          id: event.id,
          event_title: event.title.replace(/ /g, '-'),
          event: event
        }
      })
    }
  }
}
</script>
